export const CREATE_SESSION_POST_REQUEST = 'CREATE_SESSION_POST_REQUEST';
export const CREATE_SESSION_POST_REQUEST_ERROR = 'CREATE_SESSION_POST_REQUEST_ERROR';
export const CREATE_SESSION_POST_REQUEST_SUCCESS = 'CREATE_SESSION_POST_REQUEST_SUCCESS';
